module.exports = __webpack_public_path__ + "static/img/hk.4a3cee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hk.png
// module id = CsNR
// module chunks = 0